var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8571,
    cy: 12.8571,
    r: 12.8571,
    fill: "#5F58BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5295 19.0536C12.9879 19.0536 12.4789 19.0354 12 19C12.2096 19.6685 12.8289 20.1234 13.5295 20.1234C14.23 20.1234 14.8494 19.6685 15.0589 19C14.58 19.0354 14.0711 19.0536 13.5295 19.0536Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1071 13.3571V11.75C17.1071 9.67893 15.4282 8 13.3571 8C11.2861 8 9.60714 9.67893 9.60714 11.75V13.3571C9.60714 15.125 8 15.5536 8 16.5714C8 17.4821 10.0893 18.1786 13.3571 18.1786C16.625 18.1786 18.7143 17.4821 18.7143 16.5714C18.7143 15.5536 17.1071 15.125 17.1071 13.3571Z",
    stroke: "white",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.8aaa07260cb82176007dbe1a437c0d0c.svg";
export { ForwardRef as ReactComponent };